/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface PlacePredictionDto
 */
export interface PlacePredictionDto {

    /**
     * Google Places unique identifier
     *
     * @type {string}
     * @memberof PlacePredictionDto
     */
    placeId: string;

    /**
     * Full human-readable description of the place
     *
     * @type {string}
     * @memberof PlacePredictionDto
     */
    description: string;

    /**
     * Primary name (e.g. \"Ospedale Civile di Brescia\")
     *
     * @type {string}
     * @memberof PlacePredictionDto
     */
    mainText: string;

    /**
     * Secondary context (e.g. \"Brescia, BS, Italy\")
     *
     * @type {string}
     * @memberof PlacePredictionDto
     */
    secondaryText: string;
}
